import { useEffect, useState } from "react";
import TagsInput from "react-tagsinput";
import axiosInstance from "../../../axiosInterceptor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { ProductSchema } from "../../../Schema/Schema";
import "react-tagsinput/react-tagsinput.css";
import { AttributeInput } from "../../../Components/AttributeInputType";
import { Sizemultiselect } from "../../../Components/Labels";
import Select from "react-select";
import {
 AttributeStructuredata,
 fetchAllData,
 transformAttributeData,
} from "../../../helper/ProductAttributeHandling";
// import { Button } from "reactstrap";
import ProductImageUploader from "../Catalogue/components/ProductImageUploader";
import { selectStyles } from "../../../utils/selectStyles";
import CodeEditor from "../../../Components/CodeEditor";

const AddProduct = () => {
 const { id } = useParams();
 const location = useLocation();
 const editdata = location.state;
 const [btnloading, setBtnLoading] = useState(false);
 const [categoryData, setCategoryData] = useState([]);
 const [combinedattributeData, setcombinedattributeData] = useState([]);
 const [selectedValues, setSelectedValues] = useState({});
 const [sizedata, setsizedata] = useState([]);
 const [brands, setBrands] = useState([]);
 const [keywords, setkeywords] = useState([]);
 const [updateData, setUpdatedata] = useState({});
 const navigator = useNavigate();

 useEffect(() => {
  const fetchBrands = async () => {
   const res = await axiosInstance.get("/brand");
   const { data } = res.data;
   const options = data.map((brand) => ({
    value: brand.id,
    label: brand.name,
   }));
   setBrands(options);
  };

  fetchBrands();
 }, []);

 useEffect(() => {
  const initialize = async () => {
   if (editdata?.updateId) {
    await fetchAllData(`/productdetail/${editdata?.updateId}`, setUpdatedata);
   }
   await fetchAllData(`/category`, setCategoryData);
   await fetchAllData("/attribute-children", setcombinedattributeData);
   await fetchAllData("/size", setsizedata);
  };

  initialize();
  handleCategoryChange(id);
 }, [editdata]);

 const handleInputChange = (key, value) => {
  setSelectedValues((prevValues) => ({
   ...prevValues,
   [key]: value,
  }));
 };

 const onSave = (key, selectedValues) => {
  setSelectedValues((prevValues) => ({
   ...prevValues,
   [key]: selectedValues,
  }));
 };

 const initialValues = {
  name: "",
  sku: "",
  quantity:null,
  weight:null,
  retail_price:null,
  retail_discount:null,
  offer_price:null,
  retail_GST:null,
  description: "",
  tag: [],
  relatedProduct: [],
  sizes: [],
  showInSingle: true,
  category_id: [],
  homeSectionId: [],
  collection_id: [],
  attributes: [],
  images: [],
  colour_id: [],
  productlabels: [],
  brandIds: [],
  meta_title: "",
  meta_keyword: "",
  meta_description: "",
  optionType: "Stitching",
  postId: "",
 };

 const { errors, values, setFieldValue, touched, handleChange, handleSubmit } =
  useFormik({
   initialValues,
   validationSchema: ProductSchema,
   onSubmit: async (values) => {
    setBtnLoading(true);
    try {
     values.attributes = transformAttributeData(selectedValues);
     values.showInSingle = true;
     if (values.optionType === "Stitching" || values.optionType === "Other") {
      delete values.sizes;
     }

     if (!values.postId) {
          delete values.postId;
        }
        
     const response = updateData?.id
      ? await axiosInstance.put(`/product/${updateData?.id}`, values)
      : await axiosInstance.post(`/product`, values);
     if (response.status === 200) {
      toast.success(response.data.message);
      navigator(`/products/${id}`, {
       state: { editdata },
      });
     }
    } catch (error) {
     const responseError = error?.response?.data?.message;
     toast.error(responseError);
    } finally {
     setBtnLoading(false);
    }
   },
  });

 useEffect(() => {
  if (updateData && updateData?.id) {
   setFieldValue("name", updateData?.name);
   setFieldValue("sku", updateData?.sku);
   setFieldValue("retail_price", updateData?.retail_price || 0);
   setFieldValue("retail_discount", updateData?.retail_discount || 0);
   setFieldValue("offer_price", updateData?.offer_price || 0);
   setFieldValue("quantity", updateData?.quantity || 0);
   setFieldValue("weight", updateData?.weight || 0);
   setFieldValue("description", updateData?.description);
   setFieldValue("tag", updateData?.tag);
   setFieldValue("relatedProduct", updateData?.relatedProducts || []);
   setFieldValue("meta_title", updateData?.meta_title);
   setFieldValue("meta_keyword", updateData?.meta_keyword);
   setFieldValue("meta_description", updateData?.meta_description);
   setFieldValue("retail_GST", updateData?.retail_GST);
   setFieldValue("attributes", updateData?.attributeValues);
   setFieldValue("showInSingle", true);
   setFieldValue("sizes", updateData?.sizes);
   setFieldValue("postId", updateData?.instagramVideo?.[0]?.postId || null);
   setFieldValue(
    "brandIds",
    updateData?.ProductBrand?.map((b) => b.brand_id) || []
   );
   setFieldValue("optionType", updateData.optionType);
   setkeywords(updateData.search_keywords);
   const combinedImages = (updateData?.image || []).map((original, index) => ({
    original,
    thumbImage: updateData?.thumbImage?.[index] || "",
    mediumImage: updateData?.mediumImage?.[index] || "",
   }));
   if (updateData?.Collection && Array.isArray(updateData.Collection)) {
    const collectionIds = updateData.Collection.map(
     (item) => item.collection_id
    );
    setFieldValue("collection_id", collectionIds);
   }

   if (updateData?.items && Array.isArray(updateData.items)) {
    const sectionId = updateData.items.map(
     (data) => data.homeSectionId
    );
    setFieldValue("homeSectionId", sectionId);
   }

   setFieldValue("images", combinedImages);

   if (updateData?.catalogue_id) {
    setFieldValue("catalogue_id", updateData?.catalogue_id);
   }
   const categoriesId =
    updateData?.categories &&
    updateData?.categories?.map((item) => item?.category_id);
   setFieldValue("category_id", categoriesId);

   if (
    updateData?.attributes &&
    Array.isArray(updateData?.attributes) &&
    updateData?.attributes?.length > 0
   ) {
    const transformedData = AttributeStructuredata(updateData?.attributes);
    setSelectedValues(transformedData);
   }
  }
 }, [updateData]);

 useEffect(() => {
  if (values.sizes && values.sizes.length > 0) {
   const totalQuantity = values.sizes.reduce((total, item) => {
    return total + (item.quantity || 0);
   }, 0);

   if (totalQuantity !== values.quantity) {
    setFieldValue("quantity", totalQuantity);
   }
  }
 }, [values.sizes, values.quantity, setFieldValue]);

 const handleOfferPrice = (event) => {
  const { name, value } = event.target;
  handleChange(event);

  let retailPrice = parseFloat(values.retail_price) || 0;
  let discount = parseFloat(values.retail_discount) || 0;

  if (name === "retail_price") {
   retailPrice = parseFloat(value) || 0;
  } else if (name === "retail_discount") {
   discount = parseFloat(value) || 0;
  }
  let offerPrice = retailPrice || 0;
  if (discount > 0) {
   offerPrice = (retailPrice - (retailPrice * discount) / 100).toFixed(2);
  }
  setFieldValue("offer_price", offerPrice);
 };

 const handleCategoryChange = (id) => {
  const selectedCategories = values.category_id;
  if (selectedCategories.includes(id)) {
   setFieldValue(
    "category_id",
    selectedCategories.filter((catId) => catId !== id)
   );
  } else {
   setFieldValue("category_id", [...selectedCategories, id]);
  }
 };

 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5">
     <h3 className="page-title">{updateData?.id ? "Update" : "Add"} product</h3>
    </div>
    <div className="row  grid-margin stretch-card">
     <div className="col-md-12">
      <form onSubmit={handleSubmit}>
       <div className="row grid ">
        <div className="col-lg-8">
         <div className=" rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-s">
          <div className="row g-0 mr-2">
           <div className="col-4 mb-2">
            <div className="form-group">
             <label className="col-form-label ">Name</label>
             <input
              className="form-control form-control-sm w-100 border border-dark"
              type="text"
              id="name"
              name="name"
              placeholder="Enter name"
              value={values.name}
              onChange={handleChange}
             />
             {touched.name && errors.name && (
              <small className="text-danger">{errors.name}</small>
             )}
            </div>
           </div>

           <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">SKU</label>
             <input
              className="form-control form-control-sm border border-dark"
              type="text"
              id="sku"
              name="sku"
              placeholder="Enter sku"
              value={values.sku}
              onChange={handleChange}
             />

             {touched.sku && errors.sku && (
              <small className="text-danger">{errors.sku}</small>
             )}
            </div>
           </div>

           <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="form-group ">
             <label className="col-form-label ">Price</label>
              <input
               className="form-control form-control-sm w-100 border border-dark"
               type="number"
               id="retail_price"
               name="retail_price"
               placeholder="Enter price"
               min={0}
               value={values.retail_price}
               onChange={handleOfferPrice}
              />
             {touched.retail_price && errors.retail_price && (
              <small className="text-danger">{errors.retail_price}</small>
             )}
            </div>
           </div>

           <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Discount</label>
              <input
               className="form-control form-control-sm w-100 border border-dark"
               type="number"
               id="retail_discount"
               name="retail_discount"
               min={0}
               placeholder="Enter discount"
               value={values.retail_discount}
               onChange={(e) => {
                handleOfferPrice(e);
               }}
              />
             {touched.retail_discount && errors.retail_discount && (
              <small className="text-danger">{errors.retail_discount}</small>
             )}
            </div>
           </div>

           <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Offer Price</label>
              <input
               className="form-control form-control-sm w-100 border border-dark"
               type="number"
               id="offer_price"
               name="offer_price"
               min={0}
               placeholder="Enter offer price"
               value={values.offer_price}
               readOnly
              />
            </div>
           </div>

           <div className="col-lg-4 col-md-3 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Quantity</label>
             <input
              className="form-control form-control-sm border border-dark"
              type="number"
              id="quantity"
              name="quantity"
              min={0}
              placeholder="Enter quantity"
              value={values.quantity}
              onChange={handleChange}
             />
             {touched.quantity && errors.quantity && (
              <small className="text-danger">{errors.quantity}</small>
             )}
            </div>
           </div>
           <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">GST</label>
              <input
               type="number"
                className="form-control form-control-sm w-100 border border-dark"
               placeholder="Enter GST"
               aria-label="retail_GST"
               min={0}
               value={values?.retail_GST}
               name="retail_GST"
               onChange={handleChange}
               aria-describedby="basic-addon1"
              />
            </div>
           </div>
           <div className="col-lg-4 col-md-3 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Weight</label>
              <input
               className="form-control form-control-sm w-100 border border-dark"
               type="number"
               id="weight"
               name="weight"
               min={0}
               placeholder="Enter weight"
               value={values.weight}
               onChange={handleChange}
              />
             {touched.weight && errors.weight && (
              <small className="text-danger">{errors.weight}</small>
             )}
            </div>
           </div>

           <div className="col-sm-4">
                         <div className="form-group">
                          <label className="col-form-label ">Instagram Post Id</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="postId"
                            name="postId"
                            value={values.postId}
                            onChange={handleChange}
                            placeholder="Enter Post Id"
                          />

                          {touched.postId && errors.postId && (
                            <small className="text-danger">{errors.postId}</small>
                          )}
                        </div>
                      </div>
           {combinedattributeData &&
            combinedattributeData.length > 0 &&
            combinedattributeData
             .filter((attribute) => attribute?.type !== "Label")
             .map((attribute) => (
              <div className="col-lg-6 col-md-6 col-sm-12" key={attribute?.key}>
               <div className="form-group">
                <label className="col-form-label ">{attribute?.name}</label>
                <AttributeInput
                 attribute={attribute}
                 selectedValues={selectedValues || ""}
                 onSave={onSave}
                 handleInputChange={handleInputChange}
                />
               </div>
              </div>
             ))}

           <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Meta Title</label>
             <input
              className="form-control form-control-sm w-100 border border-dark"
              type="text"
              id="meta_title"
              name="meta_title"
              placeholder="Enter meta title"
              value={values.meta_title}
              onChange={handleChange}
             />
             {touched.meta_title && errors.meta_title && (
              <small className="text-danger">{errors.meta_title}</small>
             )}
            </div>
           </div>

           <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Meta keyword</label>
             <input
              className="form-control form-control-sm w-100 border border-dark"
              type="text"
              id="meta_keyword"
              name="meta_keyword"
              placeholder="Enter meta keyword"
              value={values.meta_keyword}
              onChange={handleChange}
             />
             {touched.meta_keyword && errors.meta_keyword && (
              <small className="text-danger">{errors.meta_keyword}</small>
             )}
            </div>
           </div>

           <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Meta description</label>
             <input
              className="form-control form-control-sm w-100 border border-dark"
              type="text"
              id="meta_description"
              name="meta_description"
              placeholder="Enter meta keyword"
              value={values.meta_description}
              onChange={handleChange}
             />
             {touched.meta_description && errors.meta_description && (
              <small className="text-danger">{errors.meta_description}</small>
             )}
            </div>
           </div>

           <div className="col-lg-6 col-md-6 col-sm-12">
             <label className="col-form-label">Related Products SKU</label>
             <TagsInput
             style={{ paddingBottom: "10px" }}
            className="border border-dark react-tagsinput"
             
              value={values?.relatedProduct}
              onChange={(newTags) => setFieldValue("relatedProduct", newTags)}
               inputProps={{
                
    placeholder: "Enter Sku",
  }}
             />
           </div>

           <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Description</label>

             <CodeEditor
              placeholder="Enter product description..."
              value={values.description}
              onChange={(val) => setFieldValue("description", val)}
              />
             {touched.description && errors.description && (
              <small className="text-danger">{errors.description}</small>
             )}
            </div>
           </div>

           <div className="col-lg-12 col-md-6 col-sm-12">
            <div className="form-group">
             <label className="col-form-label ">Image</label>
             <small className="form-text ">
              Required image size: 750px × 1125px (.png, .jpg, .jpeg, .webp)
             </small>
             <ProductImageUploader
              initialImages={values.images}
              onUploadComplete={(allImages) => {
               setFieldValue("images", allImages);
              }}
             />
             {touched.images && errors.images && (
              <small className="text-danger">{errors.images}</small>
             )}
            </div>
           </div>

           {/* <div className="col-lg-12 col-md-6 mt-3">
            <div className="form-group">
             <label className="col-form-label ">Video (Optional)</label>
             <small className="form-text ">Maximum Sizes 7MB</small>
             <Upload
              label="image-video"
              initialImage={values.video}
              onChange={(imgUrl) =>
               setFieldValue("video", imgUrl ? imgUrl : "")
              }
              apiUrl={"uploads?label=product"}
             />
            </div>
           </div> */}

           <label className="mt-5">Search Keywords</label>
           <div className="col-lg-12 col-md-12 col-sm-12 keyword-container">
            {keywords &&
             keywords?.length > 0 &&
             keywords.map((keyword, index) => (
              <span key={index} className="keyword-badge">
               {keyword}
              </span>
             ))}
           </div>
          </div>
         </div>
        </div>

        <div className="col-lg-4">
         <div className="row rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-s">
          <div className="col-sm-12">
           <div className="form-group">
            <label className="col-form-label " style={{fontSize:"17px",fontWeight:"normal"}}>Select Categories</label>
            <div
             className="scroll-hide pd-20 col-xs-12">
             <ul className="">
              {categoryData &&
               categoryData?.length > 0 &&
               categoryData?.map((item, index) => {
                return (
                 <li className="list-unstyled" key={index}>
                  <div className="custom-control custom-checkbox">
                   <input
                    className="custom-control-input"
                    type="checkbox"
                    id={`category-${item.id}`}
                    name="category_id"
                    value={item.id}
                    checked={values.category_id.includes(item.id)}
                    onChange={() => handleCategoryChange(item.id)}
                   />
                   <label
                    className="custom-control-label mx-2"
                    htmlFor={`category-${item.id}`}
                   >
                    {item.name}
                   </label>
                  </div>

                  <ul className="mx-2">
                   {item?.children &&
                    item?.children?.length > 0 &&
                    item?.children?.map((child, childindex) => (
                     <li className="list-unstyled" key={childindex}>
                      <div className="custom-control custom-checkbox">
                       <input
                        className="custom-control-input"
                        type="checkbox"
                        id={`category-${child.id}`}
                        name="category_id"
                        value={child.id}
                        checked={values.category_id.includes(child.id)}
                        onChange={() => handleCategoryChange(child.id)}
                       />
                       <label
                        className="custom-control-label mx-2 text-nowrap"
                        htmlFor={`category-${child.id}`}
                       >
                        {child.name}
                       </label>
                      </div>
                     </li>
                    ))}
                  </ul>
                 </li>
                );
               })}
              {touched.category_id && errors.category_id && (
               <small className="text-danger">{errors.category_id}</small>
              )}
             </ul>
            </div>
           </div>
          </div>

          {/* <div className="col-sm-12">
           <div className="form-group">
            <label className="col-form-label " style={{fontSize:"17px",fontWeight:"normal"}}>Select Collection</label>

            <div  className="scroll-hide pd-20 col-xs-12" >
             <ul className="p-0 m-0">
              {collectionData?.map((item, index) => (
               <li className="list-unstyled" key={index}>
                <div className="custom-control custom-checkbox">
                 <input
                  className="custom-control-input"
                  type="checkbox"
                  id={`collection-${item.id}`}
                  name="collection_id"
                  value={item.id}
                  checked={values.collection_id.includes(item.id)}
                  onChange={() => handleCollectionChange(item.id)}
                 />
                 <label
                  className="custom-control-label mx-2 text-nowrap"
                  htmlFor={`collection-${item.id}`}
                 >
                  {item.name}
                 </label>
                </div>
               </li>
              ))}

              {touched.collection_id && errors.collection_id && (
               <small className="text-danger">{errors.collection_id}</small>
              )}
             </ul>
            </div>
           </div>
          </div> */}



          {/* <div className="col-sm-12">
           <div className="form-group">
            <label className="col-form-label " style={{fontSize:"17px",fontWeight:"normal"}}>Select Home Section</label>

            <div className="scroll-hide pd-20 col-xs-12" >
             <ul className="p-0 m-0">
              {homeItem?.map((item, index) => (
               <li className="list-unstyled" key={index}>
                
                <div className="custom-control custom-checkbox">
                 <input
                  className="custom-control-input"
                  type="checkbox"
                  id={`homeSectionId-${item.id}`}
                  name="homeSectionId"
                  value={item.id}
                  checked={values.homeSectionId.includes(item.id)}
                  onChange={() => handleSectionChange(item.id)}
                 />
                 <label
                  className="custom-control-label mx-2 text-nowrap"
                  htmlFor={`homeSectionId-${item.id}`}
                 >
                  {item.title}
                 </label>
                </div>
               </li>
              ))}

              {touched.homeSectionId && errors.homeSectionId && (
               <small className="text-danger">{errors.homeSectionId}</small>
              )}
             </ul>
            </div>
           </div>
          </div> */}

          <div
           className="col-sm-12 mt-4"
           style={{ display: "flex", flexDirection: "row", gap: "10px" }}
          >
           <div className="custom-control custom-radio">
            <input
             type="radio"
             id="radioStitching"
             name="optionType"
             className="custom-control-input"
             value="Stitching"
             checked={values.optionType === "Stitching"}
             onChange={handleChange}
            />
            <label className="custom-control-label " htmlFor="radioStitching">
             Stitching
            </label>
           </div>

           <div className="custom-control custom-radio mt-3">
            <input
             type="radio"
             id="radioSizes"
             name="optionType"
             className="custom-control-input"
             value="Size"
             checked={values.optionType === "Size"}
             onChange={handleChange}
            />
            <label className="custom-control-label " htmlFor="radioSizes">
             Sizes
            </label>
           </div>

           <div className="custom-control custom-radio mt-3">
            <input
             type="radio"
             id="radioOther"
             name="optionType"
             className="custom-control-input"
             value="Other"
             checked={values.optionType === "Other"}
             onChange={handleChange}
            />
            <label className="custom-control-label  " htmlFor="radioOther">
             Other
            </label>
           </div>
          </div>

          {combinedattributeData &&
           combinedattributeData?.length > 0 &&
           combinedattributeData
            ?.filter((attribute) => attribute?.type === "Label")
            ?.map((attribute) => (
             <div className="col-lg-12 col-md-6 col-sm-12" key={attribute?.key}>
              <div className="form-group">
               <label className="col-form-label ">{attribute?.key}</label>
               <AttributeInput
                attribute={attribute}
                selectedValues={selectedValues || ""}
                onSave={onSave}
                handleInputChange={handleInputChange}
               />
              </div>
             </div>
            ))}

          {values.optionType === "Size" && sizedata && sizedata?.length > 0 && (
           <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="form-group">
             <Sizemultiselect
              className="form-control form-control-sm"
              sizedata={sizedata}
              values={values?.sizes}
              touched={touched}
              setFieldValue={setFieldValue}
              sizeErrors={errors.sizes}
             />
            </div>
           </div>
          )}

          <div className="col-lg-12">
           <div className="form-group">
            <label>Brands</label>

            <Select
             isMulti
             options={brands}
             value={brands.filter((brand) =>
              values.brandIds.includes(brand.value)
             )}
             onChange={(selectedOptions) => {
              const ids = selectedOptions.map((opt) => opt.value);
              setFieldValue("brandIds", ids);
             }}
              styles={selectStyles}
            />
           </div>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12">
           <div className="form-group">
            <label className="col-form-label">Tags</label>

            <TagsInput
             className="react-tagsinput border border-dark"
             value={values?.tag}
             onChange={(newTags) => setFieldValue("tag", newTags)}
            />
           </div>
          </div>
         </div>
        </div>
       </div>

       <div className="form-group text-center mt-3">
        <button type="submit" className="btn btn-primary" disabled={btnloading}>
         {btnloading ? (
          <>
           <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
           />
           Processing...
          </>
         ) : updateData?.id ? (
          "Update"
         ) : (
          "Add"
         )}
        </button>

        <button
         onClick={() => {
          navigator(-1);
         }}
         type="button"
         className="btn btn-danger mx-2"
        >
         Cancel
        </button>
       </div>
      </form>
     </div>
    </div>
   </div>
  </>
 );
};

export default AddProduct;
